import type { AxiosInstance } from 'axios';
import qs from './utils/query-string.js';
import type * as HcpApi from './interfaces/hcp.js';

export class HcpClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getHcpProfile = async (params: HcpApi.GetHcpProfile.Request) => {
    const query = qs.stringify({
      hcpId: params.hcpId,
      searchIndex: params.searchIndex,
    });
    return this.authenticatedClient.get<HcpApi.GetHcpProfile.Response>(`/hcp-profile?${query}`).then(r => r.data);
  };
}